module.exports = __webpack_public_path__ + "img/feature_01.72b905c8.jpg";